/**
 * The chart's meters as the legacy pages read them: the shape of the XML parse
 * `GetPatientDevice` used to leak into the templates (`meter.MeterID._text`).
 *
 * One mapper for the pages that list a chart's meters (UserDevices.vue and
 * CptPage.vue), because a meter is *keyed* by `MeterID` - the serial number,
 * else the row id - and the key an enrolment is made under (AddPatientCpt,
 * AddMeterCpt: `device_model`) has to be the key the other page offers. Two
 * mappers drifting apart is an enrolment on one page that the other cannot see.
 *
 * @param {object[]} items  `GET /patients/{patient}/devices` rows
 * @param {(code: string) => string} [modelName]  a model code's display name, for a row with none of its own
 */
export function meterRowsFromDevices(items, modelName) {
  return (items || []).map((device) => {
    const name = device.display_name || (modelName ? modelName(device.device_type) : '') || '';

    return {
      MeterID: { _text: device.serial_number || String(device.id) },
      MeterExID: { _text: device.external_id || '' },
      // `_cdata` is what the templates read (the XML parse main did); `_text`
      // alone left every model name "undefined".
      MeterName: { _text: name, _cdata: name },
      MeterType: { _text: device.device_type || '' },
      GatewayID: { _text: device.gateway_id || '' },
    };
  });
}
